import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ScheduledDashboards from "../components/Admin/ScheduledDashboards";

export default function ScheduledDashboardsPage() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-5xl p-4 md:p-8">
      <button
        onClick={() => navigate("/dashboard")}
        className="mb-4 flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800"
      >
        <ArrowLeft size={15} />
        Back to dashboards
      </button>
      <ScheduledDashboards selfServe />
    </div>
  );
}
